import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, ShieldIcon } from 'lucide-react';
import { SparkleIcon } from './Icons';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
export function OfferSection() {
  const [bumpSelected, setBumpSelected] = useState(false);
  const basePrice = 12990;
  const bumpPrice = 4490;
  const total = basePrice + (bumpSelected ? bumpPrice : 0);
  const formatPrice = (n: number) => n.toLocaleString('es-AR', {
    minimumFractionDigits: 0
  });
  const handleBumpToggle = () => {
    const next = !bumpSelected;
    setBumpSelected(next);
    if (next && typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: '20 Oraciones para fortalecer la fe de los niños',
        content_type: 'product',
        value: bumpPrice,
        currency: 'ARS'
      });
    }
  };
  const SHOPIFY_BASE_URL = 'https://ebookpromax.online/cart/add?id=48776739487963&quantity=1';
  const SHOPIFY_BUMP_URL = 'https://ebookpromax.online/cart/add?id=48776790540507&quantity=1';
  const checkoutUrl = bumpSelected ? SHOPIFY_BUMP_URL : SHOPIFY_BASE_URL;
  const handleCheckout = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Historias infantiles para dormir en paz',
        value: total,
        currency: 'ARS',
        num_items: bumpSelected ? 2 : 1
      });
    }
  };
  return <section id="oferta" className="py-24 px-6 lg:px-8 bg-cream" data-id="element-137">
      <div className="max-w-3xl mx-auto" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-xl shadow-indigo/5 border border-blush/30" data-id="element-139">
          <div className="text-center mb-8" data-id="element-140">
            <span className="inline-block bg-blush/40 text-indigo text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full mb-6" data-id="element-141">
              ⏳ Oferta por tiempo limitado
            </span>
            <h2 className="text-3xl md:text-4xl font-serif font-medium text-indigo mb-6" data-id="element-142">
              Lleváte hoy
            </h2>

            {/* Ebook cover */}
            <div className="flex justify-center mb-6" data-id="element-143">
              <motion.img initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6
            }} src="https://cdn.magicpatterns.com/uploads/t15Zhok8bgmfUUe93G46yx/PORTADA_LIBRO_33_CUENTOS.png" alt="Portada del libro - 33 cuentos espirituales para dormir" className="w-48 md:w-56 drop-shadow-2xl" data-id="element-144" />
            </div>

            <div className="flex items-baseline justify-center gap-4 mb-3" data-id="element-145">
              <span className="text-xl text-indigo/40 line-through" data-id="element-146">
                $24.990 ARS
              </span>
              <span className="text-5xl md:text-6xl font-serif font-medium text-indigo" data-id="element-147">
                ${formatPrice(basePrice)}
              </span>
              <span className="text-xl text-indigo/60" data-id="element-148">ARS</span>
            </div>
            <p className="text-indigo/60 text-sm" data-id="element-149">
              Pago único · Sin suscripciones · Acceso inmediato
            </p>
          </div>

          <ul className="space-y-3 mb-8 max-w-md mx-auto" data-id="element-150">
            {['Ebook con 33 cuentos espirituales', 'Acceso inmediato en PDF', 'Compatible con cualquier dispositivo', 'Actualizaciones gratuitas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-indigo/80" data-id="element-151">
                <CheckIcon className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-152" />
                <span data-id="element-153">{item}</span>
              </li>)}
          </ul>

          {/* Order bump */}
          <motion.div animate={bumpSelected ? {} : {
          boxShadow: ['0 0 0 0 rgba(212, 175, 55, 0)', '0 0 30px 6px rgba(212, 175, 55, 0.55)', '0 0 0 0 rgba(212, 175, 55, 0)']
        }} transition={{
          duration: 1.8,
          repeat: bumpSelected ? 0 : Infinity,
          ease: 'easeInOut'
        }} className={`relative overflow-hidden border-2 border-dashed rounded-2xl p-6 mb-4 cursor-pointer transition-colors ${bumpSelected ? 'border-gold bg-gold/10' : 'border-gold/70 bg-blush/10 hover:border-gold'}`} onClick={handleBumpToggle} role="button" tabIndex={0} onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleBumpToggle();
          }
        }} data-id="element-154">
            {/* Flash sweep effect */}
            {!bumpSelected && <motion.div aria-hidden="true" className="pointer-events-none absolute inset-y-0 -left-1/2 w-1/2 bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-12" animate={{
            left: ['-50%', '150%']
          }} transition={{
            duration: 2.2,
            repeat: Infinity,
            repeatDelay: 1.2,
            ease: 'easeInOut'
          }} data-id="element-155" />}

            <div className="relative flex items-start gap-4" data-id="element-156">
              <div className="pt-1" data-id="element-157">
                <motion.div animate={bumpSelected ? {} : {
                scale: [1, 1.18, 1],
                boxShadow: ['0 0 0 0 rgba(212, 175, 55, 0.7)', '0 0 0 10px rgba(212, 175, 55, 0)', '0 0 0 0 rgba(212, 175, 55, 0)']
              }} transition={{
                duration: 1.4,
                repeat: bumpSelected ? 0 : Infinity,
                ease: 'easeInOut'
              }} className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-colors ${bumpSelected ? 'bg-gold border-gold' : 'border-gold bg-white'}`} role="checkbox" aria-checked={bumpSelected} data-id="element-158">
                  {bumpSelected && <CheckIcon className="w-4 h-4 text-white" strokeWidth={3} data-id="element-159" />}
                </motion.div>
              </div>
              <div className="flex-1 flex flex-col sm:flex-row gap-4" data-id="element-160">
                <img src="https://cdn.magicpatterns.com/uploads/3aWi1Hj6eyitQccT5ikdDS/PORTADA_ORDER_BUMP.png" alt="20 Oraciones para fortalecer la fe de los niños" className="w-24 sm:w-28 flex-shrink-0 drop-shadow-xl mx-auto sm:mx-0" data-id="element-161" />
                <div className="flex-1 text-center sm:text-left" data-id="element-162">
                  <p className="text-xs font-bold tracking-widest uppercase text-gold mb-2" data-id="element-163">
                    ¡Sumá a tu pedido!
                  </p>
                  <h4 className="font-serif text-xl text-indigo mb-2" data-id="element-164">
                    20 Hermosas Oraciones sencillas, luminosas y llenas de amor
                    para fortalecer la FE de los niños.
                  </h4>
                  <p className="text-indigo/70 text-sm mb-3 leading-relaxed" data-id="element-165">
                    Ilustracioes hermosas para incluso leugo imprimir y
                    encuadrar.
                  </p>
                  <div className="flex items-baseline gap-2 justify-center sm:justify-start flex-wrap" data-id="element-166">
                    <span className="text-indigo/40 line-through text-sm" data-id="element-167">
                      $9.990
                    </span>
                    <span className="text-2xl font-serif text-indigo" data-id="element-168">
                      ${formatPrice(bumpPrice)}
                    </span>
                    <span className="bg-gold text-white text-xs font-bold px-2 py-1 rounded-full ml-2" data-id="element-169">
                      55% OFF
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Image revealed after order bump selection */}
          <AnimatePresence data-id="element-170">
            {bumpSelected && <motion.div initial={{
            opacity: 0,
            height: 0,
            marginBottom: 0
          }} animate={{
            opacity: 1,
            height: 'auto',
            marginBottom: 16
          }} exit={{
            opacity: 0,
            height: 0,
            marginBottom: 0
          }} transition={{
            duration: 0.4
          }} className="overflow-hidden" data-id="element-171">
                <div className="bg-gradient-to-br from-blush/20 to-gold/10 rounded-2xl p-6 flex flex-col sm:flex-row items-center gap-4 border border-gold/30" data-id="element-172">
                  <img src="https://cdn.magicpatterns.com/uploads/5YvKDcWL5qzh4fVHLuLG5Z/PORTADA_ORDER_BUMP.png" alt="20 Oraciones para fortalecer la fe de los niños" className="w-32 md:w-36 drop-shadow-xl flex-shrink-0" data-id="element-173" />
                  <div className="text-center sm:text-left" data-id="element-174">
                    <div className="inline-flex items-center gap-2 text-gold font-bold text-sm mb-2" data-id="element-175">
                      <SparkleIcon className="w-4 h-4" data-id="element-176" />
                      <span data-id="element-177">¡Excelente elección!</span>
                    </div>
                    <p className="text-indigo/80 text-sm leading-relaxed" data-id="element-178">
                      Sumaste <strong data-id="element-179">20 oraciones</strong> para acompañar a tu
                      hijo cada noche y fortalecer su fe con palabras llenas de
                      luz.
                    </p>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>

          {bumpSelected && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} className="flex justify-between items-center bg-indigo/5 rounded-xl px-6 py-4 mb-6" data-id="element-180">
              <span className="font-medium text-indigo" data-id="element-181">Total</span>
              <span className="text-2xl font-serif text-indigo" data-id="element-182">
                ${formatPrice(total)} ARS
              </span>
            </motion.div>}

          <a href={checkoutUrl} onClick={handleCheckout} className="flex items-center justify-center gap-2 bg-indigo text-cream font-bold text-lg px-8 py-5 rounded-full hover:scale-[1.02] transition-transform duration-300 shadow-lg shadow-indigo/20" data-id="element-183">
            <SparkleIcon className="w-5 h-5" data-id="element-184" />
            <span data-id="element-185">SÍ, QUIERO ACCESO AHORA</span>
          </a>

          <p className="text-center text-indigo/50 text-xs mt-4" data-id="element-186">
            Pago 100% seguro · Tarjeta, Mercado Pago o transferencia
          </p>

          <div className="mt-6 flex justify-center" data-id="element-187">
            <img src="https://cdn.magicpatterns.com/uploads/1Rq48HSvhNwB1eJfLwGGF9/MERCADOLIDER.jpg" alt="Pago seguro garantizado - Visa, Mastercard, Maestro, Mercado Pago - MercadoLíder Platinum" className="w-full max-w-md rounded-2xl" data-id="element-188" />
          </div>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mt-12 flex flex-col md:flex-row items-center gap-6 bg-white/60 rounded-2xl p-8 border border-blush/30" data-id="element-189">
          <div className="flex-shrink-0 w-16 h-16 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-190">
            <ShieldIcon className="w-8 h-8 text-gold" data-id="element-191" />
          </div>
          <div className="text-center md:text-left" data-id="element-192">
            <h3 className="font-serif text-xl text-indigo mb-2" data-id="element-193">
              Garantía de 7 días sin riesgo
            </h3>
            <p className="text-indigo/70 leading-relaxed" data-id="element-194">
              Probálo durante una semana. Si no notás cambios en el sueño de tu
              hijo, te devolvemos el 100% de tu dinero. Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}